import {Routes, Route} from 'react-router-dom';
import AuthenticationSuccessPage from './AuthenticationSuccessPage';
import Home from './Home';
import PrivacyPolicy from './PrivacyPolicy'
import Support from './Support';
import TermsOfService from './TermsOfServices';
import Navigation from './Navigation';
import Footer from './Footer';
const App = () => {
  return (
    <div>
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/authSuccess" element={<AuthenticationSuccessPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
        <Route path="/terms-of-services" element={<TermsOfService />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;